import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';


export const menuItemsTemplate  = (row, handleEdit, handleDeactivate, handleDelete, handleGatePassConfiguration) => {

    return  [
        { id: 'deactivate', icon: DoDisturbIcon, text: 'Deactivate', color: 'red', handler: handleDeactivate },
        { id: 'edit', icon: EditIcon, text: 'Edit Role', color: 'blue', handler: handleEdit },
        { id: 'delete', icon: DeleteIcon, text: 'Delete Role', color: 'red', handler: handleDelete },
        ...((row?.profile_type === "Port Employee" && row?.role === "Admin") ? 
            []
        : 
            [{
                id: 'gatepass config',
                icon: ConfirmationNumberIcon,
                text: 'Gate Pass Configuration',
                color: "#0b99da",
                handler: handleGatePassConfiguration
            }]
        )
    ];
}

export const getConditionalMenuItems = (row, menuItems, handleActivate) => {
    if (!row.active) {
      return menuItems.map(item =>
        item.id === 'deactivate'
          ? { id: 'activate', icon: CheckCircleIcon, text: 'Activate', color: 'green', handler: handleActivate }
          : item
      );
    }

    if(row.active) {
        return menuItems.filter(item => item.id !== 'delete');
    }
    return menuItems;
};
